import { Icons } from '@density/dust';

import Button from 'components/button';
import Tooltip from 'components/tooltip';
import { STAFF_ORIGIN } from 'config';

export default function StaffDriftButton({
  spaceId,
  location,
}: {
  spaceId: string | null | undefined;
  location: string;
}) {
  return (
    <Tooltip
      contents="View drift in Staff"
      placement="bottom"
      target={
        <Button
          size="small"
          type="link"
          active={false}
          disabled={!spaceId}
          aria-label={`View ${location} drift in Staff (opens in a new tab)`}
          onClick={() => {
            if (!spaceId) return;
            // Keep topology IDs as strings: their decimal suffix exceeds JS's
            // safe integer range. Staff supplies the default 90-day window.
            window.open(
              new URL(
                `/drift/locations/${encodeURIComponent(spaceId)}`,
                STAFF_ORIGIN
              ).href,
              '_blank',
              'noopener,noreferrer'
            );
          }}
          data-cy="external-link"
          trailingIcon={<Icons.ChartLine size={16} />}
        />
      }
    />
  );
}
